<template>
  <header id="app-header">
    <div id="header-menu">
      <h1 id="app-name">
        <a :href="homeURL">
          <img src="@/assets/logo-t.gif" alt="天の根 オーダーメイドシステム" />
        </a>
      </h1>
      <div class="cart-open">
        <a :href="cartURL">
          <svg width="16" height="16" viewBox="0 0 24 24">
            <path
              d="M9,20A2,2 0 0,1 7,22A2,2 0 0,1 5,20A2,2 0 0,1 7,18A2,2 0 0,1 9,20M17,18A2,2 0 0,0 15,20A2,2 0 0,0 17,22A2,2 0 0,0 19,20A2,2 0 0,0 17,18M7.2,14.63C7.19,14.67 7.19,14.71 7.2,14.75A0.25,0.25 0 0,0 7.45,15H19V17H7A2,2 0 0,1 5,15C5,14.65 5.07,14.31 5.24,14L6.6,11.59L3,4H1V2H4.27L5.21,4H20A1,1 0 0,1 21,5C21,5.17 20.95,5.34 20.88,5.5L17.3,12C16.94,12.62 16.27,13 15.55,13H8.1L7.2,14.63M9,9.5H13V11.5L16,8.5L13,5.5V7.5H9V9.5Z"
            />
          </svg>
          カートの中を見る
        </a>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "AppHeader",

  data() {
    return {
      homeURL: process.env.VUE_APP_LIT_URL_HOME,
      cartURL: process.env.VUE_APP_LIT_CART_OPEN,
    };
  },
};
</script>

<style scoped lang="stylus">

#app-header
  max-width: 950px
  margin: auto
  background-color: #f5e0df

#header-menu
  background-color: white
  border-bottom: 2px solid #d7827e

#app-name
  img
    max-height: 3em
    width: auto

.cart-open
  a
    border: 3px solid #fd6e82
    --tw-gradient-from: #fd6e82
    --tw-gradient-stops: var(--tw-gradient-from), #fd6e82, var(--tw-gradient-to, rgba(253, 177, 189, 255))

@css {
	#app-header {
		@apply pb-4
	}
	#header-menu {
		@apply py-2 px-1 flex flex-row justify-between items-end
	}
	#app-name {
		@apply order-first
	}
	.cart-open {
		@apply order-last text-right py-1
	}
  .cart-open a {
    @apply bg-gradient-to-t text-white text-sm font-bold p-1 w-3/4 rounded-lg
  }
	.cart-open svg {
		@apply inline fill-current text-white w-4 h-4 align-text-top
	}

}
</style>
